import { Cart } from "@leafly-com/reservations-api/dist/api";
import axios from "axios";

import logError from "utils/logError";

import { ReservationsApiErrorsResponse } from "../services/reservations";
import { resApiClient } from "../services/reservations-api";

export const deleteCartPromoCode = async ({
  cartId,
  promoCodeId,
}: {
  cartId: number;
  promoCodeId: number;
}): Promise<Cart> => {
  try {
    const { data } = await resApiClient.deleteCartPromoCode(
      cartId,
      promoCodeId,
    );

    return data;
  } catch (e) {
    if (axios.isAxiosError(e)) {
      const errors = (e.response?.data as ReservationsApiErrorsResponse)
        ?.errors;
      const status = e.response?.status;
      const expectedErrorCodes = [400, 422, 404];

      if (errors && status && expectedErrorCodes.includes(status)) {
        logError(errors[0].detail, {
          functionName: "deleteCartPromoCode",
          service: "reservations",
          statusCode: status,
        });

        throw new Error(errors[0].detail);
      } else {
        logError(
          e.response?.statusText ||
            e.message ||
            "Unknown error deleting promo code from cart.",
          {
            functionName: "deleteCartPromoCode",
            service: "reservations",
            statusCode: status || "UNKNOWN",
          },
        );

        throw new Error("Could not delete promo code");
      }
    } else {
      logError(e.message || "reservationUnknownError", {
        functionName: "deleteCartPromoCode",
        service: "reservations",
        statusCode: e.code || "UNKNOWN",
      });

      throw new Error("Could not delete promo code");
    }
  }
};
